export const templatesIndex = {
  header: {
    title: "Plantillas de WhatsApp",
    description:
      "Crea y edita plantillas como en Meta (header/body/footer/buttons + preview).",
    create: "Crear plantilla",
  },
  notConnected:
    'Tu cuenta no tiene WhatsApp Business conectado (WABA). Conecta primero en "WhatsApp Business".',
  filters: {
    search: "Buscar",
    searchPlaceholder: "Buscar por nombre...",
    status: "Estado",
    all: "Todos",
    category: "Categoría",
    allFem: "Todas",
    language: "Idioma",
    refresh: "Actualizar",
  },
  list: {
    loading: "Cargando plantillas...",
    emptyTitle: "No hay plantillas",
    emptyText: "Prueba cambiando filtros o crea tu primera plantilla.",
    baseBadge: "Base",
    edit: "Editar",
    duplicate: "Duplicar",
    deleteProtected: "Plantilla base: no se puede eliminar",
    delete: "Eliminar",
    prev: "← Anterior",
    next: "Siguiente →",
  },
  preview: {
    noText: "(sin texto)",
    noContent: "Sin contenido",
  },
  time: {
    now: "Ahora",
    minutesAbbr: "{n} min",
    hoursAbbr: "{n}h",
  },
  common: {
    close: "Cerrar",
    cancel: "Cancelar",
  },
  editor: {
    createTitle: "Crear plantilla",
    editTitle: "Editar plantilla",
    sectionBasic: "Básico",
    name: "Nombre (snake_case)",
    nameHintHtml:
      "Espacios se convierten en <code>_</code>. Solo <code>a-z</code>, <code>0-9</code> y <code>_</code>.",
    language: "Idioma",
    category: "Categoría",
    sectionHeader: "Header",
    enable: "Activar",
    type: "Tipo",
    headerLocationHintHtml:
      "Header LOCATION no lleva texto ni ejemplos en la plantilla. La ubicación (lat/lng + name/address) se envía al mandar el mensaje por <code>/messages</code>.",
    headerMediaHint:
      "Si usas MEDIA, tu cuenta puede requerir ejemplos/handles en revisión.",
    headerTextLabel: "Texto (máx 60)",
    headerTextPlaceholder: "Ej: Hola {{1}}, tu reserva está lista.",
    insert: "Insertar",
    autoExample: "Auto ejemplo",
    examplesHeader: "Ejemplos (header)",
    remove: "Quitar",
    headerLocationNote: "Se enviará una tarjeta de mapa al comienzo del mensaje.",
    headerMediaNote: "Este header se mostrará como adjunto (media).",
    sectionBody: "Body",
    bodyPlaceholder: "Escribe el contenido. Usa {{1}}, {{2}}...",
    examplesBody: "Ejemplos (body)",
    sectionFooter: "Footer",
    footerPlaceholder: "Texto corto (opcional, máx 60)",
    sectionButtons: "Buttons",
    addButton: "+ Añadir",
    noButtons: "Sin botones (opcional).",
    buttonTextPlaceholder: "Texto del botón (máx 25)",
    removeButton: "Eliminar",
    previewTitle: "Vista previa",
    viewPayload: "Ver payload que se envía a Meta",
    metaDebug: "Respuesta / error de Meta (debug)",
    validReady: "Listo para guardar.",
    validIncomplete: "Completa los campos requeridos antes de guardar.",
    saving: "Guardando...",
    save: "Guardar",
  },
  delete: {
    title: "Eliminar plantilla",
    irreversible: "Esta acción no se puede deshacer.",
    willDeletePre: "Se eliminará la plantilla ",
    willDeletePost: ".",
    confirmLabel: "Escribe el nombre exacto para confirmar:",
    confirmPlaceholder: "Escribe exactamente el nombre",
    confirmHint: "El botón se habilita cuando el texto coincide exactamente.",
    deleting: "Eliminando...",
    confirmDelete: "Eliminar definitivamente",
  },
  errors: {
    nameRequired: "El nombre es obligatorio.",
    nameInvalid: "Formato inválido. Usa solo a-z, 0-9 y _.",
    headerRequired: "Header text es obligatorio si el header está activo.",
    headerMax: "Header text máximo 60 caracteres.",
    bodyRequired: "El body es obligatorio.",
    bodyMax: "Body máximo 1024 caracteres.",
    footerMax: "Footer máximo 60 caracteres.",
    buttonTextRequired: "Texto del botón es obligatorio.",
    buttonTextMax: "Máximo 25 caracteres.",
    phoneInvalid: "PHONE_NUMBER debe ser E.164 (ej: +34123456789).",
    urlInvalid: "URL debe comenzar por http:// o https://",
    loadDetail: "No se pudo cargar el detalle de la plantilla.",
    save: "Error guardando plantilla.",
    deleteFailed: "No se pudo eliminar la plantilla.",
  },
  duplicate: {
    defaultBody: "Copia de plantilla. Edita el contenido. Gracias {{1}}.",
  },
};
